import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FormField from '@/components/forms/form-field';
import ManyAutocompleteField from "@/components/forms/many-autocomplete";

class DigitalLicenseStep2 extends Component {
  
  constructor(props) {
      super(props);
      this.stepSubmit = this.stepSubmit.bind(this);
      this.goBack = this.goBack.bind(this);
  }

  goBack() {
      const {prevStep} = this.props;
      prevStep();
  }

  stepSubmit(data) {
      // Pass data to wizard, tidak perlu API call karena cart/checkout flow
      this.props.onSubmit(data);
      return Promise.resolve();
  }

  render() {        
      const { handleSubmit, submitting } = this.props;
      return (
          <form onSubmit={handleSubmit((data) => {
              return this.stepSubmit(data);
          }) } className="form-layout"
                noValidate>
              <div className="form-row">
                  <div className="form-col_2">
                      <Field
                          name="performing_artist"
                          component={FormField}
                          required={true}
                          type="text"
                          placeholder="Artist Name"
                          label="Your Artist's Name"
                      />
                  </div>
                  <div className="form-col_2">
                      <Field
                          name="song_name"
                          component={FormField}
                          required={true}
                          type="text"
                          placeholder="Song Name"
                          label="Title of The Song You Remade"
                      />
                  </div>
              </div>
              <div className="form-row">
                  <div className="form-col_2">
                      <Field
                          name="song_url"
                          component={FormField}
                          required={true}
                          type="text"
                          placeholder="Song Youtube Link"
                          label="Link to the Original Song (YouTube)"
                      />
                  </div>
                  <div className="form-col_2">
                      <Field
                          name="artist_name"
                          component={FormField}
                          required={true}
                          type="text"
                          placeholder="Original Artist Name"
                          label="Name of the Original Artist"
                      />
                  </div>
              </div>
              <div className="form-row">
                  <div className="form-col_2">
                      <Field
                          name="song_writers"
                          component={FormField}
                          required={true}
                          type="text"
                          label="Writers of the Original Song"
                      />
                  </div>
                  <div className="form-col_2">
                      <Field
                          name="publishers"
                          component={ManyAutocompleteField}
                          required={true}
                          type="text"
                          url="clear/publisher/search"
                          label="Publishers of the Original song:"
                      />
                  </div>
              </div>
              <Field
                  name="album_title"
                  component={FormField}
                  required={true}
                  type="text"
                  placeholder="Ablum Title"
                  label="Your album title:"
              />
              <div className="submit-row submit-row_txt">
                  <button className="btn btn-second" onClick={ this.goBack }
                          type="button">Back</button>
                  <button
                      className="btn-red-primary"
                      disabled={ submitting }
                      type="submit">Next</button>
              </div>
          </form>
      )
  }
}

const validate = (values) => {
    const errors = {};
    if (!values.artist_name) errors.artist_name = 'Artist Name is required';
    if (!values.song_new_name) errors.song_new_name = 'Song Name is required';
    return errors;
};

const DigitalLicenseStep2Form =  reduxForm({
  form: 'digital-license-step2',    
  enableReinitialize: true,
  validate
})(DigitalLicenseStep2);

const mapState = () => {
    return {}
}
export default connect(mapState)(DigitalLicenseStep2Form);